import big from "@/store/game/bummers/big.store-partial";
import little from "@/store/game/bummers/little.store-partial";
import jackpot from "@/store/game/bummers/jackpot.store-partial";
import trivia from "@/store/game/bummers/trivia.store-partial";

export const BUMMER_TYPES = ["big", "little", "jackpot", "trivia"];

export const DEFAULT_SOUND_TRACKS_MAXIMUM = 20;

export const BUMMER_SUBMODULES = { trivia, big, little, jackpot };

export const IS_IE11 = !!window.MSInputMethodContext && !!document.documentMode;

// Hardcode full URL to improve response time
export const CONFIG_ENDPOINT_ORIGIN = window.location.origin;
export const CONFIG_ENDPOINT_PATH = "/wp-json/dev-api/v1/data/";
export const CONFIG_ENDPOINT = `${CONFIG_ENDPOINT_ORIGIN}${CONFIG_ENDPOINT_PATH}`;
